// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2gOmC","requiredAsterisk":"Info_requiredAsterisk__2gpdv"};